import { GetPortalConfigDocument, LoginDocument } from '@/api/queries';
import { User, UserConfig } from '@/models/gen/graphql';

import { ResultOf } from '@graphql-typed-document-node/core';
import { createPersistentComponentState } from '@/state';
import { customLocalStorage } from '@/state/storage';

// TODO: When the login issue for getting groups is resolved, combination can be removed.
export type SessionUser = ResultOf<typeof LoginDocument>['login']['user'] & { groups?: User['groups'] };

export type Config = ResultOf<typeof GetPortalConfigDocument>['getPortalConfig'];

export type SessionState = {
  user: SessionUser;
  config: Config & { userConfig?: UserConfig };
  allowedUrls?: string[];
  version?: string;
};

const initSessionState: SessionState = {
  user: undefined, // set on login
  config: undefined, // set on login
};

const useSession = createPersistentComponentState('session', initSessionState, {
  storage: customLocalStorage,
});

export default useSession;
